import { useSearchParams } from 'react-router-dom';

import { useEmbedBootstrap } from '../use-widget-bootstrap';

/** Сообщение при ссылке «как бренд» (query brand_expect=1), если API не разрешил brand_embed_allowed — design embed-brand-link §8.2. */
export function BrandExpectNotice() {
  const [searchParams] = useSearchParams();
  const { widgetConfig, brandEmbedAllowed } = useEmbedBootstrap();
  const expect = searchParams.get('brand_expect') === '1';
  if (!expect || widgetConfig == null || brandEmbedAllowed !== false) {
    return null;
  }
  return (
    <div
      role="status"
      className="border-b border-amber-200/90 bg-amber-50/95 px-4 py-2.5 text-center text-xs leading-snug text-amber-950 dark:border-amber-800/80 dark:bg-amber-950/35 dark:text-amber-100/95"
    >
      Режим встраивания для одной студии без выбора организации сейчас недоступен. Запись и расписание работают в обычном режиме. По вопросам подключения обратитесь к администратору студии.
    </div>
  );
}
